import { render, staticRenderFns } from "./MostRepetitiveProblemInventoryAndPoint.vue?vue&type=template&id=51749299&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/MostRepetitiveProblemInventoryAndPoint.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/MostRepetitiveProblemInventoryAndPoint.js?vue&type=script&lang=js&external"
import style0 from "./MostRepetitiveProblemInventoryAndPoint.vue?vue&type=style&index=0&id=51749299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51749299",
  null
  
)

export default component.exports